// function createModal(identifier) {
// 	const existingModal = document.getElementById(`${identifier}-Modal`);
// 	if (existingModal) {
// 		return existingModal;
// 	}

// 	const newModal = document.createElement('dialog');
// 	// newModal.setAttribute('closedby', 'closerequest');
// 	newModal.id = `${identifier}-Modal`;
// 	newModal.className = 'modal';

// 	newModal.innerHTML = `
//     <button class="close-modal">
//     <svg xmlns="http://www.w3.org/2000/svg" width="41.481" height="41.482" viewBox="0 0 41.481 41.482">
//         <g id="Group_832" data-name="Group 832" transform="translate(-1853.146 -536.146)">
//             <line id="Line_155" data-name="Line 155" x2="40.774" y2="40.774" transform="translate(1853.5 536.5)" fill="none" stroke="#fff" stroke-width="1"/>
//             <line id="Line_156" data-name="Line 156" x1="40.774" y2="40.774" transform="translate(1853.5 536.5)" fill="none" stroke="#fff" stroke-width="1"/>
//         </g>
//     </svg>
//     </button>
//     <div class="dialog-content not_checked">
//         <div class="image-wrapper">
//             <div class="not_checked">
//                 <img class="big-image" src="${limeAjax.themeURL}/assets/images/dialog/check_present.png" alt="">
//                 <img class="small-image" src="${limeAjax.themeURL}/assets/images/dialog/check_card.png" alt="">
//             </div>
//             <div class="not_winner">
//                 <img class="bonus-card" src="${limeAjax.themeURL}/assets/images/bonus-card.png" alt="">
//                 <img class="bonus-card" src="${limeAjax.themeURL}/assets/images/bonus-card.png" alt="">
//             </div>
//             <div class="winner">
//                 <img src="${limeAjax.themeURL}/assets/images/dialog/winner.png" alt="">
//             </div>
//         </div>
//         <div class="text-content">
//         <h2 id="form_heading">ΔΕΙΤΕ ΑΝ ΚΕΡΔΙΣΑΤΕ!</h2>
//         <p id="form_paragraph">Εισάγετε τον Αριθμό που θα βρείτε στο πίσω μέρος της SYNKA Card και δείτε αν κερδίσατε.</p>
//             <form class="coupon-form">
//             <input type="text" id="winning-code-input" placeholder="Αριθμός SYNKA Card">
//             <button type="button" id="check-code" class="btn btn-white">ΔΕΣ ΑΝ ΚΕΡΔΙΣΕΣ!</button>
//             <div id="code-result"></div>
//             </form>
//         </div>
//     </div>
// 	`;

// 	document.body.appendChild(newModal);

// 	const checkBtn = newModal.querySelector('#check-code');
// 	const closeBtn = newModal.querySelector('.close-modal');

// 	checkBtn.addEventListener('click', (e) => {
// 		e.preventDefault();
// 		couponChecker(e);
// 	});

// 	closeBtn.addEventListener('click', () => newModal.close());

// 	newModal.addEventListener('close', () => {
// 		if (newModal.querySelector('#winning-code-input') || newModal.querySelector('#code-result')) {
// 			newModal.querySelector('#winning-code-input').value = '';
// 			newModal.querySelector('#code-result').textContent = '';
// 		}
// 		checkBtn.disabled = false;
// 		newModal.addEventListener(
// 			'transitionend',
// 			() => {
// 				newModal.remove();
// 			},
// 			{ once: true },
// 		);
// 	});
// 	return newModal;
// }

// function openModal(e) {
// 	let modalId = 'win-btn';

// 	if (e && e.target && e.target.id) {
// 		modalId = e.target.id;
// 	}
// 	const modal = createModal(modalId);

// 	modal.showModal();
// }

// async function couponChecker(e) {
// 	const button = e.target;
// 	const modal = button.closest('dialog');
// 	const input = modal.querySelector('#winning-code-input');
// 	const result = modal.querySelector('#code-result');
// 	const dialogContent = modal.querySelector('.dialog-content');
// 	const couponForm = modal.querySelector('.coupon-form');
// 	const formHeading = modal.querySelector('#form_heading');
// 	const formParagraph = modal.querySelector('#form_paragraph');
// 	const code = input.value.trim();

// 	if (!code) {
// 		result.textContent = 'Παρακαλώ εισάγετε έναν κωδικό';
// 		return;
// 	}

// 	button.disabled = true;
// 	result.textContent = 'Έλεγχος...';

// 	try {
// 		const response = await fetch(limeAjax.url, {
// 			method: 'POST',
// 			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
// 			body: new URLSearchParams({
// 				action: 'check_winning_code',
// 				code: code,
// 				// competition: competition,
// 				nonce: limeAjax.nonce,
// 			}),
// 		});

// 		if (!response.ok) throw new Error('Η απόκριση δικτύου δεν ήταν σωστή');

// 		const res = await response.json();

// 		formHeading.textContent = res.success ? 'ΣΥΓΧΑΡΗΤΗΡΙΑ!' : 'ΔΕΝ ΚΕΡΔΙΣΑΤΕ ΑΥΤΗ ΤΗ ΦΟΡΑ…';
// 		formParagraph.textContent = res.success
// 			? 'Είσαι ένας από τους τυχερούς νικητές. Κάλεσε στο +30 28210 36900 για να μάθεις πως θα παραλάβεις το δώρο σου.”'
// 			: 'αλλά η τύχη σας περιμένει την επόμενη! Κάθε χρήση της SYNKA Card σας δίνει αυτόματα συμμετοχή σε κληρώσεις και διαγωνισμούς.';

// 		if (res.success) {
// 			dialogContent.classList.remove('not_checked');
// 			dialogContent.classList.add('winner');
// 			button.remove();
// 			couponForm.reset();
// 			couponForm.remove();

// 			const competitions = res.data.competition;
// 			if (competitions && competitions.length) {
// 				const textContent = modal.querySelector('.text-content');
// 				const compHTML = competitions
// 					.map(
// 						(comp) => `
//                         <li class="competition-item">
//                             <a href="${comp.url}">${comp.title}</a>
//                         </li>
//                     `,
// 					)
// 					.join('');
// 				textContent.insertAdjacentHTML(
// 					'beforeend',
// 					`
//                     <h3 class="h6">Διαγωνισμοί που κερδίσατε</h3>
//                     <ul class="competitions-list">${compHTML}</ul>`,
// 				);
// 			}
// 		} else if (!res.success) {
// 			dialogContent.classList.remove('not_checked');
// 			dialogContent.classList.add('not_winner');
// 			button.remove();
// 			couponForm.reset();
// 			couponForm.remove();
// 		}
// 	} catch (error) {
// 		result.textContent = 'Σφάλμα ελέγχου κωδικού. Δοκιμάστε ξανά.';
// 		console.error('Coupon check error:', error.message);
// 		button.disabled = false;
// 	}
// }

// const winBtn = document.getElementById('win-btn');
// if (winBtn) {
// 	winBtn.addEventListener('click', openModal);
// }

function createModal(identifier) {
	const existingModal = document.getElementById(`${identifier}-Modal`);
	if (existingModal) {
		return existingModal;
	}

	const newModal = document.createElement('dialog');
	newModal.id = `${identifier}-Modal`;
	newModal.className = 'modal';

	newModal.innerHTML = `
    <button class="close-modal">
    <svg xmlns="http://www.w3.org/2000/svg" width="41.481" height="41.482" viewBox="0 0 41.481 41.482">
        <g id="Group_832" data-name="Group 832" transform="translate(-1853.146 -536.146)">
            <line id="Line_155" data-name="Line 155" x2="40.774" y2="40.774" transform="translate(1853.5 536.5)" fill="none" stroke="#fff" stroke-width="1"/>
            <line id="Line_156" data-name="Line 156" x1="40.774" y2="40.774" transform="translate(1853.5 536.5)" fill="none" stroke="#fff" stroke-width="1"/>
        </g>
    </svg>
    </button>
    <div class="dialog-content not_checked">
        <div class="image-wrapper">
            <div class="not_checked">
                <img class="big-image" src="${limeAjax.themeURL}/assets/images/dialog/check_present.png" alt="">
                <img class="small-image" src="${limeAjax.themeURL}/assets/images/dialog/check_card.png" alt="">
            </div>
            <div class="not_winner">
                <img class="bonus-card" src="${limeAjax.themeURL}/assets/images/bonus-card.png" alt="">
                <img class="bonus-card" src="${limeAjax.themeURL}/assets/images/bonus-card.png" alt="">
            </div>
            <div class="winner">
                <img src="${limeAjax.themeURL}/assets/images/dialog/winner.png" alt="">
            </div>
        </div>
        <div class="text-content">
        <h2 id="form_heading">ΔΕΙΤΕ ΑΝ ΚΕΡΔΙΣΑΤΕ!</h2>
        <p id="form_paragraph">Εισάγετε τον Αριθμό που θα βρείτε στο πίσω μέρος της SYNKA Card και δείτε αν κερδίσατε.</p>
            <form class="coupon-form">
            <input type="text" inputmode="numeric" pattern="[0-9]+" id="bonus_card_input" placeholder="Αριθμός Bonus Card">
            <button type="button" id="check_bonus_card" class="btn btn-white">ΔΕΣ ΑΝ ΚΕΡΔΙΣΕΣ!</button>
            <div id="code-result"></div>
            </form>
        </div>
    </div>
	`;

	document.body.appendChild(newModal);
	const inputNumber = newModal.querySelector('#bonus_card_input[inputmode="numeric"]');
	const checkBtn = newModal.querySelector('#check_bonus_card');
	const closeBtn = newModal.querySelector('.close-modal');

	inputNumber.addEventListener('beforeinput', function (e) {
		const el = e.target;
		const beforeValue = el.value;
		el.addEventListener(
			'input',
			function () {
				if (el.validity.patternMismatch) {
					el.value = beforeValue;
				}
			},
			{ once: true },
		);
	});

	checkBtn.addEventListener('click', (e) => {
		e.preventDefault();
		couponChecker(e, inputNumber);
	});

	closeBtn.addEventListener('click', () => newModal.close());

	newModal.addEventListener('close', () => {
		if (newModal.querySelector('#bonus_card_input') || newModal.querySelector('#code-result')) {
			newModal.querySelector('#bonus_card_input').value = '';
			newModal.querySelector('#code-result').textContent = '';
		}
		checkBtn.disabled = false;
		newModal.addEventListener(
			'transitionend',
			() => {
				newModal.remove();
			},
			{ once: true },
		);
	});
	return newModal;
}

function openModal(e) {
	let modalId = 'win-btn';

	if (e && e.target && e.target.id) {
		modalId = e.target.id;
	}
	const modal = createModal(modalId);

	modal.showModal();
}

async function couponChecker(e, input) {
	const button = e.target;
	const modal = button.closest('dialog');
	// const input = modal.querySelector('#bonus_card_input[inputmode="numeric"]');
	const result = modal.querySelector('#code-result');
	const dialogContent = modal.querySelector('.dialog-content');
	const couponForm = modal.querySelector('.coupon-form');
	const formHeading = modal.querySelector('#form_heading');
	const formParagraph = modal.querySelector('#form_paragraph');

	const bonusCard = input.value.trim();

	if (!bonusCard) {
		result.textContent = 'Παρακαλώ εισάγετε τον κωδικό της bonus card';
		return;
	}

	button.disabled = true;
	result.textContent = 'Έλεγχος...';

	try {
		const response = await fetch(limeAjax.url, {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body: new URLSearchParams({
				action: 'check_bonus_card_winner',
				bonus_card: bonusCard,
			}),
		});

		if (!response.ok) throw new Error('Η απόκριση δικτύου δεν ήταν σωστή');

		const competitions = await response.json();
		result.textContent = '';

		if (competitions.length > 0) {
			// WINNER
			formHeading.textContent = 'ΣΥΓΧΑΡΗΤΗΡΙΑ!';
			formParagraph.textContent =
				'Είσαι ένας από τους τυχερούς νικητές. Κάλεσε στο +30 28210 36900 για να μάθεις πως θα παραλάβεις το δώρο σου.';
			dialogContent.classList.remove('not_checked', 'not_winner');
			dialogContent.classList.add('winner');

			button.remove();
			couponForm.remove();

			const compHTML = competitions
				.map(
					(comp) => `
				<li class="competition-item">
					<a href="${comp.link}">${comp.title}</a>
				</li>`,
				)
				.join('');

			modal.querySelector('.text-content').insertAdjacentHTML(
				'beforeend',
				`
				<h3 class="h6">Διαγωνισμοί που κερδίσατε</h3>
				<ul class="competitions-list">${compHTML}</ul>`,
			);
		} else {
			// NOT WINNER
			formHeading.textContent = 'ΔΕΝ ΚΕΡΔΙΣΑΤΕ ΑΥΤΗ ΤΗ ΦΟΡΑ…';
			formParagraph.textContent =
				'αλλά η τύχη σας περιμένει την επόμενη! Κάθε χρήση της SYNKA Card σας δίνει αυτόματα συμμετοχή σε κληρώσεις και διαγωνισμούς.';
			dialogContent.classList.remove('not_checked', 'winner');
			dialogContent.classList.add('not_winner');

			button.remove();
			couponForm.remove();
		}
	} catch (error) {
		result.textContent = 'Σφάλμα ελέγχου κωδικού. Δοκιμάστε ξανά.';
		console.error('Coupon check error:', error.message);
		button.disabled = false;
	}
}

const winBtn = document.getElementById('win-btn');
if (winBtn) {
	winBtn.addEventListener('click', openModal);
}
